// Switch that is used for 'opening' and 'closing' the doors
import React from "react";

export default class Switch extends React.Component {
    constructor ( props ) {
        super( props );
       
    }

    render () {
        return (
            <div className={this.props.hasDoors() ? "switch-container box-shadow-border" : "switch-container switch-container-disabled box-shadow-border"}>
                <span>Deuren dicht</span>
                <label className="switch">
                    <input type="checkbox" checked={this.props.isOpen} onChange={this.props.toggleOpenDoors} disabled={!this.props.hasDoors()} />
                    <span className="slider round"></span>
                </label>
                <span>Deuren open</span>
            </div>
        );
    }
}